import { AxiosResultDefaultError } from '../../../../api/request';

/**
 * Códigos de dominio del alta/edición de un plan de estudio.
 *
 * El formulario NO puede mostrar el `message` que llega del backend: viene en
 * inglés y es texto para desarrolladores. Así que acá se traduce la respuesta a
 * un código estable y el form decide qué decir en español.
 *
 * Antes el form mapeaba CUALQUIER `HTTP_ERROR` a "el código ya se encuentra en
 * uso": un 400 por título/grado faltante se mostraba como código duplicado,
 * sobre un código que ni siquiera existía.
 */
export type StudyPlanErrorCode =
  | 'NOT_UNIQUE_CODE'
  | 'INVALID_CODE_CHARS'
  | 'TITLE_OR_DEGREE_REQUIRED'
  | 'UNKNOWN';

/**
 * Nest devuelve dos formas distintas de 400 y se distinguen por el tipo de
 * `message`:
 *  - **array**  → errores de campo del ValidationPipe (los DTOs).
 *  - **string** → `BadRequestException('CODIGO')` lanzada por el service.
 */
const parseBody = (error: AxiosResultDefaultError) => {
  const message = (error as any)?.error?.response?.data?.message;
  return {
    fieldErrors: Array.isArray(message) ? (message as string[]) : [],
    businessCode: typeof message === 'string' ? message : '',
  };
};

export const resolveStudyPlanErrorCode = (
  error: AxiosResultDefaultError,
): StudyPlanErrorCode => {
  if (error.code !== 'HTTP_ERROR' || error.status !== 400) {
    return 'UNKNOWN';
  }

  const { fieldErrors, businessCode } = parseBody(error);

  if (fieldErrors.some((m) => m.includes('code in use'))) {
    return 'NOT_UNIQUE_CODE';
  }
  if (fieldErrors.some((m) => m.startsWith('code must contain only'))) {
    return 'INVALID_CODE_CHARS';
  }
  if (businessCode === 'STUDY_PLAN_TITLE_OR_DEGREE_REQUIRED') {
    return 'TITLE_OR_DEGREE_REQUIRED';
  }

  return 'UNKNOWN';
};
